<template>
    <div class="dealer-selection-select__wrapper tw-relative">
        <div class="dealer-selection-select">
            <dk-select
                class="dealer-selection-select__input"
                :class="{ 'dealer-selection-select__chosen': value, '!tw-border-feedback-danger': showError }"
                :value="value"
                :placeholder="placeholder"
                :options="dealerList"
                :disabled="isZipCodeInvalid"
                :property-label="'name'"
                :property-track-by="'name'"
                :is-loading="isLoading || areDealersLoading"
                :has-no-result="hasNoResult"
                is-dealer-select
                @input="handleInput"
                @click-open="onOpen"
                @close="onClose"
            />
            <dk-button
                v-if="value && !isOpen"
                class="dealer-selection-select__button tw-absolute tw-top-3 tw-right-3 !tw-w-6 !tw-h-6 tw-mt-px !tw-bg-transparent"
                is-icon-only
                @click.prevent.stop="clearSelect"
            >
                <dk-icon name="ds-close-empty" size="s" color="basic" />
            </dk-button>
        </div>
        <div
            v-if="showError"
            class="dealer-selection-select__feedback tw-text-feedback-danger tw-text-sm tw-mt-2 tw-mb-4"
        >
            {{ $t('lead-form.dealer-selection.mandatory-field') }}
        </div>
    </div>
</template>

<script>
import DkSelect from '@v4/common/components/atoms/DkSelect.vue';
import { dealerSelectionStore } from '@v4/lead-form/store/index';
import { DEALER_SELECTION_MUTATIONS } from '@v4/lead-form/store/mutations';
import { isZipCodeValid } from '@v4/lead-form/validate-zip';
import { dealersHandler } from '@v4/common/components/mixins/dealers-handler';

export default {
    name: 'DealerSelectionSelect',
    components: {
        DkSelect,
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton'),
        }),
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
    },
    mixins: [dealersHandler],
    props: {
        placeholder: {
            type: String,
            required: true,
        },
        isMandatorySelection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            theZipCode: null,
            isZipCodeInvalid: true,
            value: null,
            isOpen: false,
            isInputInvalid: false,
        };
    },
    computed: {
        zipCode() {
            return dealerSelectionStore.state.zipCode;
        },
        projectId() {
            return dealerSelectionStore.state.projectId;
        },
        showError() {
            return !this.isOpen && this.isInputInvalid && !this.isZipCodeInvalid;
        },
    },
    watch: {
        zipCode(newValue) {
            if (newValue === this.theZipCode) {
                return;
            }

            this.theZipCode = newValue;

            if (!isZipCodeValid(this.theZipCode, 5, 5, false)) {
                this.isZipCodeInvalid = true;
                this.value = null;
                this.dealerList = [];
                this.isLoading = false;
                return;
            }

            this.isZipCodeInvalid = false;
            dealerSelectionStore.commit(DEALER_SELECTION_MUTATIONS.SET_ZIP_CODE, this.theZipCode);
            this.fetchDealers(this.theZipCode, this.projectId);
        },
    },
    mounted() {
        this.theZipCode = this.zipCode;
        this.fetchDealers(this.theZipCode, this.projectId);
    },
    methods: {
        handleInput(value) {
            this.value = value;
            dealerSelectionStore.commit(DEALER_SELECTION_MUTATIONS.SET_SELECTED_DEALER, value);
        },
        onOpen() {
            this.isOpen = true;
        },
        onClose() {
            this.isOpen = false;
            if (this.isMandatorySelection) {
                this.checkInputValidity();
            }
        },
        clearSelect() {
            this.value = null;
            if (this.isMandatorySelection) {
                this.$emit('click-clear');
                this.checkInputValidity();
            }
        },
        checkInputValidity() {
            this.isInputInvalid = this.value === null;
        },
    },
};
</script>
